// removed by extract-text-webpack-plugin
module.exports = {"text":"no-records-found__text___IT_sT","text-inner":"no-records-found__text-inner___4Cyvj"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/NoRecordsFound/no-records-found.scss
// module id = 941
// module chunks = 0